var _rect, _rect2, _rect3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInprogress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.00195312,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#131313"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.99805,
    y: 2,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#FABD40"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.99805,
    y: 2,
    width: 12,
    height: 12,
    rx: 6,
    fill: "white",
    fillOpacity: 0.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59766 4V6.4H5.60166L5.59766 6.404L7.19766 8L5.59766 9.6L5.60166 9.604H5.59766V12H10.3977V9.604H10.3937L10.3977 9.6L8.79766 8L10.3977 6.404L10.3937 6.4H10.3977V4H5.59766ZM9.59766 9.8V11.2H6.39766V9.8L7.99766 8.2L9.59766 9.8ZM7.99766 7.8L6.39766 6.2V4.8H9.59766V6.2L7.99766 7.8Z",
    fill: "#121212"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogress);
export default __webpack_public_path__ + "static/media/Inprogress.de87314761cbb7a803b7b37e8093bcb5.svg";
export { ForwardRef as ReactComponent };